import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import './App.css';
import { ProductProvider } from "./pages/pagesCardapio/ProductContext";
import { AppProvider, useAppContext } from "./api/AppContext"; // Make sure both are imported
import NavBar from "./components/NavBar";

function App() {
  const isDesktop = window.innerWidth >= 768;

  return (
    <AppProvider>
      <ProductProvider>
        <Router>
          <div className={`app-container ${isDesktop ? 'desktop-layout' : 'mobile-layout'}`}>
            <AuthAwareNavBar />
            <main className="main-content">
              <AppRoutes />
            </main>
          </div>
        </Router>
      </ProductProvider>
    </AppProvider>
  );
}

// Separate component that uses the context
function AuthAwareNavBar() {
  const { isAuthenticated } = useAppContext();
  return isAuthenticated ? <NavBar /> : null;
}

export default App;